// What the doc model says about a doc that a doc row does not (TT-1273):
// its failure and its source, from the doc read (one doc) or the owner's
// many-doc read (a list page). A row carries them as `spoken`:
// { failure, source }; nothing here works them out of the row's own fields.
import AppBackService from "./appback";

// The many-doc read's bound per call (platform spoken_docs.MAX_IDS).
const MAX_IDS = 100;

// `spoken` from the doc read; null when it could not be read.
export function spokenOf(read) {
  if (!read || read.error) return null;
  return { failure: read.doc?.failure || null, source: read.source || null };
}

/**
 * `spoken` for many docs, by doc id, from the owner's many-doc read. A doc
 * the read leaves out (not visible, or gone) has none; a failed read gives
 * an empty Map, so rows stay as they were.
 */
export async function spokenFacts(userId, docIds) {
  const facts = new Map();
  for (let i = 0; i < docIds.length; i += MAX_IDS) {
    const res = await AppBackService.getSpokenDocs(userId, docIds.slice(i, i + MAX_IDS));
    if (!res || res.error) return facts;
    for (const row of res.docs || []) facts.set(row.doc?.doc_id, spokenOf(row));
  }
  return facts;
}

// Whether a doc's source is arriving live, i.e. its live cassette runs (the
// spec's Open phase): a still-running meeting opens the live tapestry.
export function liveArriving(spoken) {
  return spoken?.source?.arrival === "live" && spoken?.source?.state === "arriving";
}

// The kept audio from the doc read, when it is there to play.
export function keptAudio(spoken) {
  const audio = spoken?.source?.audio;
  return audio?.status === "ready" ? audio : null;
}
